import { HStack, Text, VStack } from '@genial/components';
import React from 'react';

import { TextSkeleton } from '../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export interface MobileInfosProps {
  infos: { label: string; value: string }[];
}

export interface MobileInfosLoadingProps {
  infos: { label: string }[];
}

export const MobileInfos: React.FC<MobileInfosProps> = ({ infos }) => {
  return (
    <VStack space="stack.nano">
      {infos.map((info, index) => (
        <HStack
          key={index}
          justifyContent="space-between"
          pb={index === infos.length - 1 ? '0' : 'stack.nano'}
          borderBottomWidth={index === infos.length - 1 ? '0' : '1'}
          borderBottomColor="neutral.lightest"
          borderStyle="solid">
          <Text color="neutral.darkest">{info.label}</Text>
          <Text>{info.value}</Text>
        </HStack>
      ))}
    </VStack>
  );
};

export const MobileInfosLoading: React.FC<MobileInfosLoadingProps> = ({ infos }) => {
  return (
    <VStack space="stack.nano">
      {infos.map((info, index) => (
        <HStack
          key={index}
          justifyContent="space-between"
          pb={index === infos.length - 1 ? '0' : 'stack.nano'}
          borderBottomWidth={index === infos.length - 1 ? '0' : '1'}
          borderBottomColor="neutral.lightest"
          borderStyle="solid">
          <Text color="neutral.darkest">{info.label}</Text>
          <TextSkeleton w="2/5" />
        </HStack>
      ))}
    </VStack>
  );
};
